import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { logIn } from '../../store/auth';

function ProtectedPage(props) {
  const { children, loggedIn, isInitial, logIn, location, ...rest } = props;

  useEffect(() => {
    (async function checkLogin() {
      isInitial && await logIn();
    }())
  }, [isInitial, logIn]);

  if (isInitial) {
    return [];
  }

  if (loggedIn) {
    return <Route {...rest} render={() => children}/>
  }

  return (
    <Redirect
      to={{
        pathname: "/login",
        state: { from: location },
      }}
    />
  );
}

export default connect(
  ({ auth }) => ({
    isInitial: auth.isInitial,
    loggedIn: auth.loggedIn,
  }),
  { logIn }
)(ProtectedPage);
